import { createSlice } from "@reduxjs/toolkit";
import { SolicitudFirmaStateInterface } from "interfaces/solicitudFirma/solicitudFirmaInterface";

export const solicitudFirmaSlice = createSlice({
    name:"solicitudFirma",
    initialState:{
      solicitudFirma:null,
      solicitudesFirma:[]
    } as SolicitudFirmaStateInterface,
    reducers:{
      onAddSolicitudFirma:(state , {payload})=>{        
       state.solicitudFirma = payload;
      },
      onAddSolicitudesFirma:(state , {payload})=>{
       state.solicitudesFirma = payload;
      },
      onResetStateSolicitudFirma:(state)=>{
       state.solicitudFirma = null;
      }
    }
});


export const { onAddSolicitudFirma, onAddSolicitudesFirma,  onResetStateSolicitudFirma} = solicitudFirmaSlice.actions;